export default "__VITE_ASSET__DVzsnlEW__"